// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const LOG_ST_EMBARQUE = {
  DigitandoMateriais: 'LOG_ST_EMBARQUE6',
  ValidandoLpcoPre: 'LOG_ST_EMBARQUE7',
  Preembarque: 'LOG_ST_EMBARQUE1',
  Transito: 'LOG_ST_EMBARQUE2',
  Atracado: 'LOG_ST_EMBARQUE9',
  EmDestinacao: 'LOG_ST_EMBARQUE10',
  Finalizado: 'LOG_ST_EMBARQUE4',
  Cancelado: 'LOG_ST_EMBARQUE5',
  ValidandoLpcoPos: 'LOG_ST_EMBARQUE8',
  Desembaracado: 'LOG_ST_EMBARQUE3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    LOG_ST_EMBARQUE6: 1,
    LOG_ST_EMBARQUE7: 2,
    LOG_ST_EMBARQUE1: 3,
    LOG_ST_EMBARQUE2: 4,
    LOG_ST_EMBARQUE9: 5,
    LOG_ST_EMBARQUE10: 6,
    LOG_ST_EMBARQUE4: 7,
    LOG_ST_EMBARQUE5: 8
  }
}
